import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Button, Divider, Drawer, Switch, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { MODAL_SIZES } from 'config/modaSettings';
import { useFormReviewPivotTableStore } from 'stores/local';
import { translateApiValue } from 'utils/translateApiValue';

import s from '../../../FormFlatTable/Content/ColumnsSettingsDrawer/ColumnsSettingsDrawer.module.scss';

const ColumnsSettingsDrawer: React.FC = () => {
  const { t } = useTranslation();
  const { columnsSettingsDrawer } = useFormReviewPivotTableStore();

  return (
    <Drawer
      width={MODAL_SIZES.m}
      open={columnsSettingsDrawer.drawerState.opened}
      onClose={columnsSettingsDrawer.drawerState.close}
      title={
        <Typography.Title level={3}>
          {t('formReview.columnsSetup')}
        </Typography.Title>
      }
      extra={
        <Button
          type="default"
          size="large"
          onClick={columnsSettingsDrawer.reset}
        >
          {t('formReview.makeAllVisible')}
        </Button>
      }
    >
      <div className={s.columnsSettingsDrawer__wrapper}>
        {columnsSettingsDrawer.entities.map((item) => (
          <React.Fragment key={item.data.id}>
            <div className={s.columnsSettingsDrawer__row}>
              <Typography.Text>{translateApiValue(item.data.name)}</Typography.Text>
              <Switch
                checkedChildren={<EyeFilled />}
                unCheckedChildren={<EyeInvisibleFilled />}
                onClick={item.toggle}
                checked={item.visible}
              />
            </div>
            <Divider />
          </React.Fragment>
        ))}
      </div>
    </Drawer>
  );
};

export default observer(ColumnsSettingsDrawer);
